import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CookieStorageService } from '../helpers/cookie-storage.service';
import { IResponse } from '../interfaces/response.interface';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private readonly cookieService = inject(CookieStorageService);
    private readonly http = inject(HttpClient);
    private readonly baseUrl = environment.baseUrl;

    async fetchPermissions(): Promise<Record<string, string> | null> {
        try {
            const res = await firstValueFrom(
                this.http.get<IResponse<Record<string, string>>>(`${this.baseUrl}/admin-user/my-permissions`)
            );
            const permissions = res.data ?? null;
            this.cookieService.set('adminPermissions', permissions);
            return permissions;
        } catch {
            return this.cookieService.get('adminPermissions') as Record<string, string> | null;
        }
    }

    canWrite(moduleSlug: string): boolean {
        const permissions = this.cookieService.get('adminPermissions') as Record<string, string> | null;
        if (!permissions) return true;
        return permissions[moduleSlug] === 'READ_WRITE';
    }

    canRead(moduleSlug: string): boolean {
        const permissions = this.cookieService.get('adminPermissions') as Record<string, string> | null;
        if (!permissions) return true;
        const level = permissions[moduleSlug];
        return level === 'READ' || level === 'READ_WRITE';
    }

    hasNoRoles(permissions: Record<string, string> | null): boolean {
        return permissions !== null && Object.keys(permissions).length === 0;
    }
}
